module.exports = __webpack_public_path__ + "media/images/emblems/Wappen_arth-401f346c97e32c97de26ab10b3fd12d5.png";